export const winSettings = {
    unique_all_time: "Never have a confirmed win before this draw",
    unique: "Can only win once this draw (may or may not have a confirmed win in previous draws)",
    non_unique: "Can win multiple times"
}
export const winSettingOptions = [
    ...Object.keys(winSettings).map(k => ({
        value: k, label: winSettings[k]
    }))
]